import '@usb-shield/react-grid/dist/library/styles/index.css'
import { createRef, KeyboardEvent, useEffect, useRef, useState } from 'react'
import { useSession } from 'next-auth/react'
import USBButton from '@usb-shield/react-button'
import { USBColumn } from '@usb-shield/react-grid'
import USBLink from '@usb-shield/react-link'
import pageHeaderStyles from '@/components/PageHeader/styles/pageHeader.module.scss'
import mobileNavBarStyles from './styles/mobileNavBar.module.scss';
import { useRouter } from 'next/router'
import { downloadDocument } from '@/modules/products/ProductOverviewPage/services/downloadDocument.service'
import { PageHeaderMenuItem } from '@/components/PageHeader/PageHeader.model';
import { useCookies } from 'react-cookie'
import RegionPicker from '@/components/RegionPicker/RegionPicker'
import { InputSearch } from '@/components/InputSearch/InputSearch'
import { useSearchBarUtil } from './util/SearchBarUtil'
import { useQueryClient } from '@tanstack/react-query'
import { convertStringIntoCamelCase } from '@/utils/strings/strings'
import { USBIconClose, USBIconBuildings } from '@usb-shield/react-icons'
import ChallengeWidgetModal from '@/modules/challenge-widget/ChallengeWidget'
import { toggleLevel4 } from './toggleLevel4';
import { toggleLevel2Callback, escapeKeyPressed, setFocusOnFirstTab, focusOnLevelThree, focusOnLevelTwo, togglebackOneLevelCallback, focusOnLevelZero } from './MobileNavBarUseEffectUtils';
import { renderFourthLevelMenuItem } from '@/components/PageHeader/RenderFourthLevelMenuItem';
import { renderSecondLevelMenuItem } from '@/components/PageHeader/util/RenderSecondLevelMenuItem';
import { removeSupportItem, removeCredentialsItem } from '@/components/PageHeader/util/RemoveMenuItems';
import { onLogoutClick, onLoginClick, toggleMenuCallback, togglebackThirdLevelCallback } from '@/components/PageHeader/util/CallbackHandlers';

const mobileHeaderNavColumn = {
  span: null,
  spans: {
    xlarge: 16,
    large: 16,
    medium: 8,
    small: 4,
  },
  offset: {
    xlarge: 0,
    large: 0,
    medium: 0,
    small: 0,
  },
  display: 'block',
  padding: 'zero',
  align: 'start',
  justify: 'stretch',
}

export const MobileNavBar = ({
  menuItems,
  imageURL,
  mainmenuId,
  regionOptions,
  isLoginSignUpDisabled,
  isSearchDisabled,
  allProductVersionsInfo,
  authWidgetConfigData,
}: any) => {
  const router = useRouter();
  const [isMobileViewport, setIsMobileViewport] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { handleSearchKeyDown } = useSearchBarUtil()
  const { data: session, status } = useSession()
  const queryClient = useQueryClient()
  const menuListWrapperRef = useRef(null)
  const levelOneMenuListWrapperRef = useRef(null)
  const levelTwoMenuListWrapperRef = useRef(null)
  const levelThreeMenuListWrapperRef = useRef(null)
  const menuWrapperRef = useRef(null)
  const backOneLevelRef = useRef(null)
  const [cookies] = useCookies(['locale', 'countryCode'])
  const isElavon: boolean = process.env.SITE_BRAND === 'elavon'
  const sandboxProductsExists: boolean = process.env.FEATURE_SANDBOX_PROJECTS === 'true'
  const handleLogout = () => onLogoutClick(router, queryClient);
  const inSessionMobileMenu = !isElavon ? [
    {
      id: 'credentials-mobile',
      value: 'Credentials',
      url: '/credentials',
    },
    {
      id: 'profile-mobile',
      value: 'Account Profile',
      url: '/profile',
    },
    {
      id: 'support-mobile',
      value: 'Support Tickets',
      url: '/support',
    },
  ] : [
    {
      id: 'dashboard-mobile',
      value: 'Dashboard',
      url: '/dashboard',
    },
    {
      id: 'account-mobile',
      value: 'Account',
      url: '/profile',
    }
  ]
  const hamburgerKeyup = (e: KeyboardEvent<HTMLDivElement>): void => {
    e.preventDefault();

    // toggle the menu if the enter key is pressed
    if (e.key === 'Enter') {
      toggleMenuCallbackWrapper();
    }
  }
  const toggleMenuCallbackWrapper = () => {
    const toggleMenuParams = {
      menuWrapperRef,
      levelOneMenuListWrapperRef,
      levelTwoMenuListWrapperRef,
      levelThreeMenuListWrapperRef,
      pageHeaderStyles
    };
    toggleMenuCallback(toggleMenuParams);
  };
  const setHamburgerCloseIconFocus = () => {
    hamburgerCloseIcon?.focus()
  }
  const setTimerOnHamburgerCloseIconFocus = (): void => {
    setTimeout(() => {
      const hamburgerCloseIcon = document.getElementById('hamburgerCloseIcon');
      if (hamburgerCloseIcon) {
        hamburgerCloseIcon.focus();
      }
    }, 1000);
  };
  const toggleLevel1Callback = (e: any, id: string, levelRef: any) => {
    if (typeof window !== 'undefined') {
      // browser code
      const isActiveClass = 'is-active'
      const levelOneMenuListWrapper = levelOneMenuListWrapperRef.current as any
      const levelOneLinks = levelRef
      // Toggle submenu wrapper
      const subMenuWrapper =
        levelOneMenuListWrapper.querySelector('.subMenuWrapper')
      const siblingList = levelOneLinks?.current?.nextElementSibling
      if (siblingList) {
        e.preventDefault()
        siblingList.classList.add(isActiveClass)
        const cloneSiblingList = siblingList.cloneNode(true)
        subMenuWrapper.innerHTML = ''
        subMenuWrapper.append(cloneSiblingList)
        levelOneMenuListWrapper.style.transform = 'none'
        levelOneMenuListWrapper.style.display = 'block'
        // Level 1 - Active Menu
        const levelOneText = document.getElementById(
          'activeLevelOneMenu'
        ) as any
        levelOneText.innerHTML = document.getElementById(id)?.innerText
        // Level 2 - Active Menu
        const levelTwoText = document.getElementById('level2-backMenu') as any
        levelTwoText.innerHTML = document.getElementById(id)?.innerText

        setTimerOnHamburgerCloseIconFocus()
      }
    }
  }
  const handleTogglebackOneLevelCallback = (): void => {
    togglebackOneLevelCallback(levelOneMenuListWrapperRef, setTimerOnHamburgerCloseIconFocus);
  }
  const togglebackSecondLevelCallback = (): void => {
    if (typeof window !== 'undefined') {
      const isActiveClass = 'is-active';
      const parent = levelTwoMenuListWrapperRef.current as any;
      parent.style = '';
      parent.previousElementSibling
        .querySelector('.is-active')
        .classList.remove(isActiveClass);

      setTimerOnHamburgerCloseIconFocus();
    }
  }
  
  const togglebackThirdLevelCallbackWrapper = (): void => {
    togglebackThirdLevelCallback(levelThreeMenuListWrapperRef);
  };
  const handleEnterKeyPressWrapper = (
    event: any,
    togglebackOneLevelCallback: () => void,
    togglebackSecondLevelCallback: () => void,
    togglebackThirdLevelCallback: () => void
  ): void => {
    const targetId = (event.target as HTMLElement)?.id;

    switch (targetId) {
      case 'levelOne':
        togglebackOneLevelCallback();
        break;
      case 'levelTwo':
        togglebackSecondLevelCallback();
        break;
      case 'levelThree':
        togglebackThirdLevelCallback();
        break;
      default:
        break;
    }
  };
  const renderFourthLevelMenuItemWrapper = (
    value: PageHeaderMenuItem,
    index: number
  ): JSX.Element | undefined => {
    return renderFourthLevelMenuItem({
      fourthLevelMenuItem: value,
      fourthLevelItemIndex: index,
      allProductVersionsInfo,
      countryCode,
      isElavon,
    });
  };
  const handleMenuOpenCallback = () => {
    setIsMenuOpen(true)
  }
  const handleMenuCloseCallback = () => {
    setIsMenuOpen(false)
  }
  
  // MFA Challenge Widget
  const featureMFA: boolean = process.env.FEATURE_MFA !== 'false'
  const [challengeModalIsOpen, setChallengeModalIsOpen] = useState<boolean>(false)
  const [activityName, setActivityName] = useState<string>('')
  const [callBackUrl, setCallBackUrl] = useState<string>('')
  useEffect(() => {}, [challengeModalIsOpen, callBackUrl])
  // End MFA Challenge Widget
  
  let countryCode = (cookies.countryCode || 'en-us').toLowerCase()
  let featureDeveloperAssistant: boolean = process.env.FEATURE_DEVELOPER_ASSISTANT !== 'false'
  let mainMenuRef: any = ''
  let hamburgerCloseIcon: HTMLElement
  let renderMobileMenuItems

  function renderFirstLevelMenuItem(firstLevelMenuItem: PageHeaderMenuItem, firstLevelItemIndex: number): JSX.Element {
    const eleID = convertStringIntoCamelCase(firstLevelMenuItem?.value || '');

    const handleClick = async (e: any) => {
      if (firstLevelMenuItem?.fileType === 'download') {
        await handleDownload(firstLevelMenuItem);
      } else {
        toggleLevel1Callback(
          e,
          firstLevelMenuItem?.id || '',
          mainMenuRef.current[firstLevelItemIndex]
        );
      }
    };

    return renderMenuItem(firstLevelMenuItem, eleID, handleClick, firstLevelItemIndex);
  }

  async function handleDownload(firstLevelMenuItem: PageHeaderMenuItem): Promise<void> {
    if (firstLevelMenuItem.documentPath) {
      await downloadDocument(
        firstLevelMenuItem.documentPath,
        firstLevelMenuItem.value || '',
        cookies.locale
      );
    }
  }

  function renderMenuItem(
    firstLevelMenuItem: PageHeaderMenuItem,
    eleID: string,
    handleClick: (e: any) => void,
    firstLevelItemIndex: number
  ): JSX.Element {
    const hasSubMenus = firstLevelMenuItem?.hasSubMenus;
    const href =
      firstLevelMenuItem?.fileType === 'download'
        ? '#toggleLevel1Callback'
        : `${firstLevelMenuItem?.url}` || '#';

    const menuItem = (
      <a
        id={`${eleID}`}
        className={mobileNavBarStyles.nested}
        ref={mainMenuRef.current[firstLevelItemIndex]}
        href={href}
        data-testid={`${eleID}`}
        onClick={handleClick}
      >
        {firstLevelMenuItem.value || ''}
      </a>
    );

    return (
      <li key={eleID}>
        {menuItem}
        {hasSubMenus && renderSubMenu(firstLevelMenuItem)}
      </li>
    );
  }

  function renderSubMenu(firstLevelMenuItem: PageHeaderMenuItem): JSX.Element {
    return (
      <ul
        className={`${mobileNavBarStyles.subMenu} ${mobileNavBarStyles.level2}`}
      >
        {firstLevelMenuItem?.menuItems?.items?.map((secondLevelMenuItem, secondLevelItemIndex) =>
          renderSecondLevelMenuItem({
            secondLevelMenuItem,
            secondLevelItemIndex,
            allProductVersionsInfo,
            countryCode,
            isElavon,
            renderFourthLevelMenuItemWrapper,
          })
        )}
      </ul>
    );
  }

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined' && window.innerWidth <= 1057) {
        setIsMobileViewport(true);
      } else {
        setIsMobileViewport(false);
      }
    };

    const element2 = levelTwoMenuListWrapperRef.current as any;
    const element1 = levelOneMenuListWrapperRef.current as any;

    const lastItemFocusOut = (event: any) => {
      setHamburgerCloseIconFocus();
    };

    const focusOnLevelThreeWrapper = () => {
      focusOnLevelThree({
        setFocusOnFirstTab,
        handleEnterKeyPress: (event: any, navigateToPreviousLevel: () => void, navigateToSecondLevel: () => void) => {
          handleEnterKeyPressWrapper(event, navigateToPreviousLevel, navigateToSecondLevel, togglebackThirdLevelCallbackWrapper);
        },
        navigateToPreviousLevel: handleTogglebackOneLevelCallback,
        navigateToSecondLevel: togglebackSecondLevelCallback,
        navigateToThirdLevel: togglebackThirdLevelCallbackWrapper,
        handleLastItemFocusOut: lastItemFocusOut,
      });
    };

    const focusOnLevelTwoWrapper = () => {
      focusOnLevelTwo({
        setFocusOnFirstTab,
        handleEnterKeyPress: handleEnterKeyPressWrapper as (event: any, navigateToPreviousLevel: () => void, navigateToSecondLevel: () => void, navigateToThirdLevel: () => void) => void,
        navigateToPreviousLevel: handleTogglebackOneLevelCallback,
        navigateToSecondLevel: togglebackSecondLevelCallback,
        navigateToThirdLevel: togglebackThirdLevelCallbackWrapper,
        handleLastItemFocusOut: lastItemFocusOut,
      });
    };

    const focusOnLevelOne = () => {
      const levelOne = document.getElementById('levelOne') as HTMLElement;
      const levelOneLastItem = levelOne?.nextElementSibling?.nextElementSibling?.firstChild?.lastChild as HTMLElement;
      setFocusOnFirstTab(levelOne, levelOneLastItem, {
        enterKeyPressed: (event: KeyboardEvent) => handleEnterKeyPressWrapper(event, handleTogglebackOneLevelCallback, togglebackSecondLevelCallback, togglebackThirdLevelCallbackWrapper),
        lastItemFocusOut,
      });
    };

    const focusOnLevelZeroWrapper = () => {
      const levelZero = document.querySelector("#menu-level1") as HTMLElement | null;
      const levelZeroLastItem = levelZero?.lastChild?.firstChild as HTMLElement;
      if (levelZero) {
        focusOnLevelZero(levelZero, levelZeroLastItem, lastItemFocusOut);
      }
    };

    const hamburgerCloseIconFocusOut = () => {
      let level0, level1, level2, level3 = false;

      const levelThreeMenuListWrapper = levelThreeMenuListWrapperRef.current as any;
      level3 = levelThreeMenuListWrapper.style.display === 'block';

      const levelTwoMenuListWrapper = levelTwoMenuListWrapperRef.current as any;
      level2 = levelTwoMenuListWrapper.style.display === 'block';

      const levelOneMenuListWrapper = levelOneMenuListWrapperRef.current as any;
      level1 = levelOneMenuListWrapper.style.display === 'block';

      const menuWrapper = menuWrapperRef.current as any;
      level0 = menuWrapper.classList.contains('isVisible');

      switch (true) {
        case level3:
          focusOnLevelThreeWrapper();
          break;

        case level2:
          focusOnLevelTwoWrapper();
          break;

        case level1:
          focusOnLevelOne();
          break;

        case level0:
          focusOnLevelZeroWrapper();
          break;
        default:
          break;
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    element2.addEventListener('click', (e: any) => toggleLevel4(e, {
      featureMFA,
      authWidgetConfigData,
      session,
      setCallBackUrl,
      setActivityName,
      setChallengeModalIsOpen,
      levelThreeMenuListWrapperRef
    }));

    document.addEventListener('keydown', (event: any) => escapeKeyPressed(event, menuWrapperRef, toggleMenuCallbackWrapper), false);

    element1.addEventListener('click', (e: any) => toggleLevel2Callback(e, levelTwoMenuListWrapperRef, setTimerOnHamburgerCloseIconFocus));

    hamburgerCloseIcon?.addEventListener('focusout', hamburgerCloseIconFocusOut, false);

    return () => {
      window.removeEventListener('resize', handleResize);

      element1.removeEventListener('click', (e: any) => toggleLevel2Callback(e, levelTwoMenuListWrapperRef, setTimerOnHamburgerCloseIconFocus));
      element2.removeEventListener('click', (e: any) => toggleLevel4(e, {
        featureMFA,
        authWidgetConfigData,
        session,
        setCallBackUrl,
        setActivityName,
        setChallengeModalIsOpen,
        levelThreeMenuListWrapperRef
      }));

      document.removeEventListener('keydown', (event: any) => escapeKeyPressed(event, menuWrapperRef, toggleMenuCallbackWrapper), false);

      hamburgerCloseIcon?.removeEventListener('focusout', hamburgerCloseIconFocusOut, false);
    };
  }, [session]);

  if (countryCode === 'us') {
    countryCode = 'en-us'
  }

  if (process.env.FEATURE_SUPPORT_TICKET !== 'true') {
    removeSupportItem(inSessionMobileMenu)
  }
  
  if (process.env.FEATURE_DEVELOPER_DASHBOARD !== 'true') {
    removeCredentialsItem(inSessionMobileMenu);
  }

  mainMenuRef = useRef(mainmenuId?.mainMenuId?.map(() => createRef())) as any
  
  if (typeof window !== 'undefined') {
    hamburgerCloseIcon = document.getElementById('hamburgerCloseIcon') as HTMLElement
  }

  if (menuItems && isMobileViewport) {
    renderMobileMenuItems = menuItems?.map(renderFirstLevelMenuItem);
  }

  return (
    <>
      {/* render MFA Challenge widget modal */}
      {challengeModalIsOpen && (
        <ChallengeWidgetModal
          callBackUrl={callBackUrl}
          challengeModalIsOpen={challengeModalIsOpen}
          setChallengeModalIsOpen={setChallengeModalIsOpen}
          authWidgetConfigData={authWidgetConfigData}
          activityName={activityName}
        ></ChallengeWidgetModal>
      )}
      <div id="showOverlay" className={mobileNavBarStyles.showOverlay}></div>
      <USBColumn
        layoutOpts={mobileHeaderNavColumn}
        addClasses={mobileNavBarStyles.fullWidth}
      >
        <div className={mobileNavBarStyles.pageHeader}>
          <nav>
            <div className={process.env.SITE_BRAND.toLowerCase() === 'elavon' ? mobileNavBarStyles.headerBar : mobileNavBarStyles.twoTierHeaderBar}>
              <button
                id="sm_menu_ham"
                className={mobileNavBarStyles.hamburgerIcon}
                data-testid="sm_menu_ham"
                tabIndex={0}
                onKeyUp={(e: any) => hamburgerKeyup(e)}
                onClick={toggleMenuCallbackWrapper}
                aria-label="Open left side menu"
              >
                <svg
                  id="svg-692205d2-4c90-4f66-afd9-87504749e1e0"
                  aria-hidden="true"
                  viewBox="0 0 20 20"
                  width="30"
                  height="30"
                  className="single"
                  focusable="false"
                >
                  <path
                    id="pathSVG-692205d2-4c90-4f66-afd9-87504749e1e0"
                    d="M19 4.75H1v-1.5h18zm0 10.5H1v1.5h18zm0-6H1v1.5h18z"
                  />
                </svg>
              </button>
              <button
                id="hamburgerCloseIcon"
                className={mobileNavBarStyles.hamburgerCloseIcon}
                data-testid="hamburgerCloseIcon"
                tabIndex={0}
                onKeyUp={(e: any) => hamburgerKeyup(e)}
                onClick={toggleMenuCallbackWrapper}
                aria-label="Close left side menu"
              >
                {!isElavon ? (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 16 16" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M15.3759 7.99989C15.3759 10.9951 13.5703 13.6949 10.8022 14.8389C8.03405 15.9828 4.8493 15.3453 2.73481 13.2239C0.620331 11.1026 -0.00684422 7.91577 1.1461 5.15137C2.29905 2.38696 5.00471 0.590178 7.9999 0.599893C12.085 0.604302 15.3955 3.91481 15.3999 7.99989H15.3759ZM11.1999 5.59989L8.7999 7.99989L11.1999 10.3999L10.3999 11.1999L7.9999 8.79989L5.5999 11.1999L4.7999 10.3999L7.1999 7.99989L4.7999 5.59989L5.5999 4.79989L7.9999 7.19989L10.3999 4.79989L11.1999 5.59989ZM10.343 2.26958C12.6627 3.2278 14.1759 5.49005 14.1759 7.99989H14.1999C14.1955 11.4222 11.4222 14.1955 7.9999 14.1999C5.49007 14.2096 3.22197 12.7052 2.25476 10.3892C1.28755 8.07321 1.81206 5.40255 3.58334 3.62439C5.35463 1.84622 8.02323 1.31136 10.343 2.26958Z" fill="#2D2D3E"/>
                              </svg>) : (<USBIconClose
                                          colorVariant='grey80'
                                          size={24}
                                          addClasses={mobileNavBarStyles.profileIcon} />)}
              </button>
              <div className={isElavon ? mobileNavBarStyles.logoAndTaglineContainer : mobileNavBarStyles.twoTierLogoAndTaglineContainer}>
                <USBLink href={'/'} addClasses={mobileNavBarStyles.profileLink}>
                  <img
                    src={imageURL}
                    alt={process.env.SITE_BRAND + ' logo'}
                  />
                </USBLink>
              </div>
              <div className={mobileNavBarStyles.navButton}>
                {status !== 'loading' && !session && !isLoginSignUpDisabled && (
                  <USBLink
                    href="/login"
                    addClasses={isElavon ? mobileNavBarStyles.loginLink : mobileNavBarStyles.twoTierLoginLink}
                    variant="loud"
                    size="default"
                    handleClick={onLoginClick}
                    dataTestId="login-link"
                  >
                    Login
                  </USBLink>
                )}
              </div>
            </div>
            <div className={mobileNavBarStyles.menuWrapper} ref={menuWrapperRef}>
              <div className={mobileNavBarStyles.listWrapper} ref={menuListWrapperRef}>
                {!isSearchDisabled && (
                  <InputSearch
                    inputID="edp_search_input_mobile"
                    inputName="query_string_mobile"
                    handleSearchKeyDown={handleSearchKeyDown}
                  />
                )}
                <ul id="menu-level1" className={`${mobileNavBarStyles.menu} ${mobileNavBarStyles.level1}`}>
                    {renderMobileMenuItems}
                    {status !== 'loading' &&
                      session &&
                      inSessionMobileMenu.map((item, i) => (
                        <li key={item.id} className={mobileNavBarStyles.inSessionMobileMenu}>
                          {item.value == 'Credentials' ? (
                            sandboxProductsExists && (
                                <a
                                  id={`${item.id}`}
                                  className={mobileNavBarStyles.nested}
                                  key={item.id}
                                  href={`${item.url}` || '#'}
                                >
                                  {item.value}
                                </a>
                            )
                          ) : (
                              <a
                                id={`${item.id}`}
                                className={mobileNavBarStyles.nested}
                                key={item.id}
                                href={`${item.url}` || '#'}
                              >
                                {item.value}
                              </a>
                          )}
                        </li>
                      ))}
                    {featureDeveloperAssistant &&  (
                      <li className={mobileNavBarStyles.inSessionMobileMenu}>
                            <a href={'/'} className={`${mobileNavBarStyles.devAssistantName} ${mobileNavBarStyles.devAssistantLink}`} data-testid={'developer-assistant'}>
                              <img src={"/header/developer-assistant-mobile.png"} alt={'Developer Assistant'} /> <span>Developer Assistant</span>
                            </a>
                      </li>                      
                    )}
                    {process.env.FEATURE_GEOLOCATION && (
                      <li className={mobileNavBarStyles.inSessionMobileMenu}>
                        <RegionPicker
                          options={regionOptions}
                          menuIsOpen={isMenuOpen}
                          handleMenuOpenCallback={handleMenuOpenCallback}
                          handleMenuCloseCallback={handleMenuCloseCallback}
                          classNamePrefix={'mobileFilter'}
                          selectorStyles={{}}
                        />
                      </li>
                    )}
                    {status !== 'loading' && session && (
                      <li className={mobileNavBarStyles.inSessionMobileMenu}>
                        <USBButton
                          ctaStyle="standard"
                          emphasis="minimal" 
                          size="medium"
                          handleClick={handleLogout}
                          addClasses={mobileNavBarStyles.logoutBtn}
                          dataTestId="onLogoutClick"
                        >
                          <USBIconBuildings
                            colorVariant='grey80'
                            size={24}
                            addClasses={mobileNavBarStyles.profileIcon} />Log Out
                        </USBButton>
                      </li>
                    )}
                </ul>
              </div>
              <div
                className={mobileNavBarStyles.listWrapper}
                ref={levelOneMenuListWrapperRef}
              >
                <button
                  id="levelOne"
                  className={`${mobileNavBarStyles.backOneLevel} ${mobileNavBarStyles.levelOne}`}
                  ref={backOneLevelRef}
                  data-testid="togglebackOneLevelCallback"
                  onClick={handleTogglebackOneLevelCallback}
                  tabIndex={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                  </svg>
                  <span id="level1-backMenu">Main Menu</span>
                </button>
                <div
                  id="activeLevelOneMenu"
                  className={mobileNavBarStyles.activeLevelOneMenu}
                ></div>
                <div
                  className={`${mobileNavBarStyles.subMenuWrapper} subMenuWrapper`}
                ></div>
              </div>
              <div
                className={mobileNavBarStyles.listWrapper}
                ref={levelTwoMenuListWrapperRef}
              >
                <button
                  id="levelTwo"
                  className={`${mobileNavBarStyles.backOneLevel} ${mobileNavBarStyles.levelTwo}`}
                  ref={backOneLevelRef}
                  data-testid="togglebackSecondLevelCallback"
                  onClick={togglebackSecondLevelCallback}
                  tabIndex={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                  </svg>
                  <span id="level2-backMenu">Back</span>
                </button>
                <div
                  id="activeLevelTwoMenu"
                  className={mobileNavBarStyles.activeLevelTwoMenu}
                ></div>
                <div
                  className={`${mobileNavBarStyles.subMenuWrapper} subMenuWrapper`}
                ></div>
              </div>
              <div
                className={mobileNavBarStyles.listWrapper}
                ref={levelThreeMenuListWrapperRef}
              >
                <button
                  id="levelThree"
                  className={`${mobileNavBarStyles.backOneLevel} ${mobileNavBarStyles.levelThree}`}
                  ref={backOneLevelRef}
                  data-testid="togglebackThirdLevelCallback"
                  onClick={togglebackThirdLevelCallbackWrapper}
                  tabIndex={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                  </svg>
                  <span id="level3-backMenu">Back</span>
                </button>
                <div
                  id="activeLevelThreeMenu"
                  className={mobileNavBarStyles.activeLevelThreeMenu}
                ></div>
                <div
                  className={`${mobileNavBarStyles.subMenuWrapper} subMenuWrapper`}
                ></div>
              </div>
            </div>
          </nav>
        </div>
      </USBColumn>
    </>
  )
}